import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: false,
  data: {
    regularSales: 0,
    discountedSales: 0,
    associateSales: 0,
    annualSpend: 0,
    avgOrderValue: 0,
  },
};

const mapInsightsData = (insightsData) => {
  const { regularPricePercent, salesPromotionPricePercent, associatePurchasesPercent, annualSpend, avgOrderValue } =
    insightsData;

  return {
    regularSales: Math.round(regularPricePercent),
    discountedSales: Math.round(salesPromotionPricePercent),
    associateSales: Math.round(associatePurchasesPercent),
    avgOrderValue: Math.round(avgOrderValue),
    annualSpend: Math.round(annualSpend),
  };
};

const clientPurchaseInsights = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.CLIENT_INSIGHTS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.CLIENT_INSIGHTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: mapInsightsData(payload),
      };
    case actionTypes.CLIENT_INSIGHTS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case actionTypes.CLIENT_INSIGHTS_CLEAR:
      return {
        loading: false,
        error: false,
        data: { ...INITIAL_STATE.data },
      };
    default:
      return state;
  }
};

export default clientPurchaseInsights;
